import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Mail, FileText, GitBranch, Clock, Megaphone, ArrowLeft, Clipboard, Activity, Send } from 'lucide-react';
import './EmailAdmin.css';

function EmailAdminLayout() {
  const navigate = useNavigate();

  return (
    <div className="email-admin">
      <div className="email-admin-header">
        <button className="email-admin-back" onClick={() => navigate('/admin')}>
          <ArrowLeft size={16} />
          Back to Admin
        </button>
        <div className="email-admin-title">
          <Mail size={22} />
          <h2>Email Automation</h2>
        </div>
      </div>

      <div className="email-admin-tabs">
        <NavLink
          to="/admin/email/templates"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <FileText size={16} />
          Templates
        </NavLink>
        <NavLink
          to="/admin/email/render"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <Clipboard size={16} />
          Quick Render
        </NavLink>
        <NavLink
          to="/admin/email/rules"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <GitBranch size={16} />
          Rules
        </NavLink>
        <NavLink
          to="/admin/email/queue"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <Clock size={16} />
          Queue
        </NavLink>
        <NavLink
          to="/admin/email/logs"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <Activity size={16} />
          Logs
        </NavLink>
        <NavLink
          to="/admin/email/compose"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <Send size={16} />
          Compose
        </NavLink>
        <NavLink
          to="/campaigns"
          className={({ isActive }) => `email-tab-btn ${isActive ? 'active' : ''}`}
        >
          <Megaphone size={16} />
          Campaigns
        </NavLink>
      </div>

      <div className="email-admin-content">
        <Outlet />
      </div>
    </div>
  );
}

export default EmailAdminLayout;
